import { render } from "./LayoutContainer.vue?vue&type=template&id=ea8fac08"
const script = {}

import "./LayoutContainer.vue?vue&type=style&index=0&id=ea8fac08&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__